var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('test-card',{attrs:{"testId":this.$route.params.testId}}):_c('v-progress-circular',{attrs:{"v-model":_vm.loading,"color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }